const index = () => import(/* webpackChunkName: "herb" */ './Index');

export default {
  routes: [
    //项目
    {
      path: '/intelligent/2019/index',
      name: 'intelligent2019Index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/intelligent/V2019/router.js